// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3idN5","tab":"Tabs_tab__U0ItZ","tabActive":"Tabs_tabActive__oynct"};